export { default as MultiplePaymentsForm } from './Form/MultiplePaymentsForm'
export { default as TotalPayment } from './TotalPayment/TotalPayment'
